import React, { useEffect } from "react";
import { useState } from "react";
import { useAPI } from "../../hooks/useAPI";
import { AuthContext } from "./AuthContext";

// Função helper para carregar usuário do sessionStorage de forma síncrona
const getStoredUser = () => {
  try {
    const storageData = sessionStorage.getItem("loggedUser");
    if (storageData) {
      return JSON.parse(storageData);
    }
  } catch (error) {
    console.error("[AuthProvider] Erro ao carregar usuário do sessionStorage:", error);
  }
  return null;
};

export const AuthProvider = ({ children }) => {
  // Inicializar o usuário de forma síncrona a partir do sessionStorage
  const [user, setUser] = useState(() => getStoredUser());
  const API = useAPI();

  useEffect(() => {
    // Validar e atualizar usuário do sessionStorage apenas uma vez na montagem
    // Isso garante que se o sessionStorage foi atualizado, o estado seja sincronizado
    const storedUser = getStoredUser();
    if (storedUser && (!user || user.id !== storedUser.id)) {
      setUser(storedUser);
    }
  }, []); // Executar apenas uma vez na montagem

  const updateLocalUser = (partial) => {
    setUser((prev) => {
      if (!prev) return prev;
      const next = { ...prev, ...partial };
      sessionStorage.setItem("loggedUser", JSON.stringify(next));
      return next;
    });
  };

  const signin = async (login, password, _type, unit) => {
    try {
      const data = await API.signin(login, password, unit);

      // /access/login retorna { status, token, user: { ... }, mustChangePassword }
      if (data && data.user) {
        const userData = { 
          ...data.user, 
          token: data.token, 
          unit,
          mustChangePassword: data.mustChangePassword || false,
        };
        setUser(userData);
        setLoggedUser(userData);
        
        // Retornar objeto com informações sobre necessidade de mudança de senha
        return {
          success: true,
          mustChangePassword: data.mustChangePassword || false,
        };
      }

      // Caso de credenciais inválidas tratadas em useAPI.signin
      return { success: false };
    } catch (error) {
      // Evita quebrar a aplicação com erro não tratado
      console.error("[AuthProvider.signin] Erro ao autenticar:", error);
      return { success: false };
    }
  };
  const signout = async () => {
    setUser(null);
    setLoggedUser("");
  };
  const setLoggedUser = (user) => {
    sessionStorage.setItem("loggedUser", JSON.stringify(user));
  };
  return (
    <AuthContext.Provider value={{ user, signin, signout, updateLocalUser }}>
      {children}
    </AuthContext.Provider>
  );
};
